import { lazy } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  type RouteObject,
} from 'react-router-dom';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { MainLayoutWrapper } from '../layouts/MainLayoutWrapper';
import { GameLayout } from '../layouts/GameLayout';

const LandingPage = lazy(() => import('../pages/LandingPage').then((m) => ({ default: m.LandingPage })));
const LoginPage = lazy(() => import('../pages/LoginPage').then((m) => ({ default: m.LoginPage })));
const RegisterPage = lazy(() => import('../pages/RegisterPage').then((m) => ({ default: m.RegisterPage })));
const HubPage = lazy(() => import('../pages/HubPage').then((m) => ({ default: m.HubPage })));
const FriendsPage = lazy(() => import('../pages/FriendsPage').then((m) => ({ default: m.FriendsPage })));
const LeaderboardsPage = lazy(() => import('../pages/LeaderboardsPage').then((m) => ({ default: m.LeaderboardsPage })));
const ProfilePage = lazy(() => import('../pages/ProfilePage').then((m) => ({ default: m.ProfilePage })));
const ChatPage = lazy(() => import('../pages/ChatPage').then((m) => ({ default: m.ChatPage })));
const GamePage = lazy(() => import('../pages/GamePage').then((m) => ({ default: m.GamePage })));
const NotFoundPage = lazy(() => import('../pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage })));

// eslint-disable-next-line react-refresh/only-export-components
export const routes: RouteObject[] = [
  // Public routes (no layout)
  { path: '/', element: <LandingPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },

  // Main layout routes
  {
    element: <MainLayoutWrapper />,
    children: [
      { path: '/home', element: <HubPage /> },
      { path: '/friends', element: <ProtectedRoute><FriendsPage /></ProtectedRoute> },
      { path: '/leaderboards', element: <LeaderboardsPage /> },
      { path: '/leaderboards/:gameId', element: <LeaderboardsPage /> },
      { path: '/profiles/:userId', element: <ProfilePage /> },
      { path: '/profiles/me', element: <ProtectedRoute><ProfilePage /></ProtectedRoute> },
      { path: '/chat', element: <ProtectedRoute><ChatPage /></ProtectedRoute> },
      { path: '/chat/:roomId', element: <ProtectedRoute><ChatPage /></ProtectedRoute> },
    ],
  },

  // Game layout (fullscreen)
  {
    path: '/play/:gameId',
    element: <GameLayout><GamePage /></GameLayout>,
  },

  { path: '*', element: <NotFoundPage /> },
];

// eslint-disable-next-line react-refresh/only-export-components
export function createRouter() {
  return createBrowserRouter(
    routes.map((route) => ({
      ...route,
      errorElement: <ErrorBoundary><div>Route error</div></ErrorBoundary>,
    })),
  );
}

export function AppRouter() {
  const router = createRouter();
  return <RouterProvider router={router} />;
}
